<template>
    <div class="model-popup" v-if="open">
        <div class="backdrop" @click="closePopup"></div>
        <div class="popup-box" :style="{ top: position }">
            <img class="close-icon" :src="asset('images/icon_close01.svg')" @click="closePopup" />

            <div class="popup-header">{{ model.title }}</div>

            <div class="popup-image-block">
                <youtube-player
                    :model="model"
                    :id="model.video_link"
                    :thumbnail-desktop="model.thumbnail_video"
                    :thumbnail-mobile="model.thumbnail_video"
                    v-if="model.video_link"
                />

                <img class="popup-image" :src="asset(model.thumbnail_video)" v-else />
            </div>

            <p class="popup-description">{{ model.description }}</p>

            <div class="button-block">
                <a
                    @click="setPromotionClick"
                    class="btn btn-arrow btn-arrow-right btn-secondary"
                    :data-motorshow-slug="slug"
                    data-motorshow-type="Promotion"
                    :href="model.promotion_link"
                    v-if="model.promotion_link"
                    >โปรโมชัน</a
                >

                <a
                    class="btn btn-messenger btn-primary"
                    data-motorshow-type="Chat"
                    @click="setChatClick"
                    :data-motorshow-slug="slug"
                    :href="saleLink"
                    >แชทกับเซล</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        saleLink: {
            type: String
        },

        model: {
            type: Object
        },

        open: {
            type: Boolean
        }
    },

    computed: {
        slug() {
            return this.model.model ? this.model.model.slug : this.model.car_model_category;
        }
    },

    data() {
        return {
            position: 0
        };
    },

    watch: {
        open(newValue, oldValue) {
            this.position = this.getPosition();
        }
    },

    methods: {
        getPosition() {
            const pos = window.pageYOffset + 40;
            return pos + "px";
        },

        closePopup() {
            this.$emit("update:open", false);
        },

        setPromotionClick() {},

        setChatClick() {}
    }
};
</script>

<style lang="scss">
@import "../../../sass/variables";

* {
    :focus {
        outline: none;
    }
}

.model-popup {
    .backdrop {
        position: fixed;
        z-index: 100;
        top: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.75);
    }

    .popup-box {
        position: absolute;
        z-index: 101;
        top: 60px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #fff;
        width: calc(100% - 30px);
        padding: 0 17px;

        @media ($md) {
            width: 650px;
            padding: 0 30px;
        }

        @media ($lg) {
            width: 790px;
        }

        .close-icon {
            width: 88px;
            height: 28px;
            position: absolute;
            top: 20px;
            right: 17px;
            cursor: pointer;

            @media ($md) {
                top: 30px;
                right: 30px;
            }
        }

        .popup-header {
            font-size: 36px;
            font-family: $font-bold;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-flow: column;
            margin-top: 46px;
            margin-bottom: 30px;

            @media ($md) {
                font-size: 48px;
            }

            &::after {
                content: "";
                display: block;
                width: 160px;
                height: 8px;
                background-color: $primary-red;
                margin-top: 7px;
            }
        }

        .popup-image-block {
            height: 174px;

            @media ($md) {
                height: 410px;
            }

            .popup-image {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .popup-description {
            color: #424242;
            font-size: 24px;
            margin-top: 20px;
            margin-bottom: 20px;

            @media ($md) {
                white-space: pre-wrap;
            }
        }

        .button-block {
            display: flex;
            flex-flow: column-reverse;
            align-items: center;
            justify-content: center;
            margin-bottom: 30px;

            @media ($md) {
                flex-flow: row;
            }

            .btn {
                font-size: 24px;
                width: 100%;

                @media ($md) {
                    width: auto;
                    padding: 0 55px;
                }

                &:last-child {
                    margin-bottom: 30px;

                    @media ($md) {
                        margin-bottom: 0;
                    }
                }

                &:not(:last-child) {
                    @media ($md) {
                        margin-bottom: 0;
                        margin-right: 20px;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/motor-show/ModelPopup.vue